import React, { useState } from "react";
import { Flex, Popover, Typography } from "antd";
import { EditOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { SbButton } from "uiCore";

// One row's Reason for Shortlisting in the redeployment reduction tables —
// an info icon that opens a Popover with the full reason on hover/focus.
// A Popover (not a Tooltip) because the content can be interactive: when
// onEdit is passed (Reduction Detail's live draft), it adds an Edit action;
// without it (View Planning's saved plan) the cell is read-only. antd's
// Popover directly (SbPopover isn't exported from uiCore), same as
// SkillGapList's skill descriptions.
const ShortlistReasonCell = ({ reason, onEdit }) => {
  // Controlled so Edit can close the Popover before the edit dialog opens —
  // a Popover's z-index sits above a Modal's, so it would otherwise float
  // over the dialog's mask.
  const [open, setOpen] = useState(false);

  const handleEdit = () => {
    setOpen(false);
    onEdit();
  };

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      placement="left"
      trigger={["hover", "focus"]}
      title="Reason for Shortlisting"
      content={
        <Flex vertical gap={8} style={{ maxWidth: 320 }}>
          <Typography.Paragraph style={{ marginBottom: 0, whiteSpace: "pre-wrap" }}>{reason}</Typography.Paragraph>
          {onEdit && (
            <Flex justify="flex-end">
              <SbButton buttonType="secondary" size="small" icon={<EditOutlined />} onClick={handleEdit}>
                Edit
              </SbButton>
            </Flex>
          )}
        </Flex>
      }
    >
      {/* Plain span as the Popover's trigger — antd needs a ref-able child to
          position it, and SbButton doesn't forward refs (same reason
          SbTooltip wraps its children). */}
      <span>
        <SbButton
          buttonType="action"
          size="small"
          icon={<InfoCircleOutlined />}
          aria-label="View reason for shortlisting"
        />
      </span>
    </Popover>
  );
};

export default ShortlistReasonCell;
